/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionFieldCondition
 */
export interface QuestionFieldCondition {
    /**
     * 
     * @type {string}
     * @memberof QuestionFieldCondition
     */
    question_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionFieldCondition
     */
    selected_values: Array<string>;
}

/**
 * Check if a given object implements the QuestionFieldCondition interface.
 */
export function instanceOfQuestionFieldCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_name" in value;
    isInstance = isInstance && "selected_values" in value;

    return isInstance;
}

export function QuestionFieldConditionFromJSON(json: any): QuestionFieldCondition {
    return QuestionFieldConditionFromJSONTyped(json, false);
}

export function QuestionFieldConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionFieldCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'question_name': json['question_name'],
        'selected_values': json['selected_values'],
    };
}

export function QuestionFieldConditionToJSON(value?: QuestionFieldCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'question_name': value.question_name,
        'selected_values': value.selected_values,
    };
}

